import { ROLES } from '../../_config/roles';
import { 
    findAllClientsByNamePaged,
    findAllClientsPaged,
    findAllOrderListLiveGroupByClient,
    findAllOrderListGroupByClient,
    findAllOrderListGroupDeparturesByClient,
    findAllOrderDetailByOrderAndRefAndColor,
    pdfViewListByOrder,
    pdfViewListLiveByClient,
    pdfViewListByClient,
    excelViewListLiveByClient,
    excelViewListByClient,
    findAllOrderListGroupDeparturesByClientFilter,
    pdfDepartureListByClientDate,
    viewListGenerailViewFilter,
    viewListGenerailViewFilterByOptions,
    findOrderGroupById,
    viewListGenerailViewFilterByOptionsNotDispatched,
    viewListGenerailSellerViewFilter,
    viewListGenerailViewlSelleFilterByOptions,
    viewListGenerailViewlSelleFilterByOptionsNotDispatched
} from '../../_services/order_list_view.service';
import { getRol } from '../../_utils/storage_handler';

export const findAllClientsByNamePagedEvent = async (name, page, count) => {
    let res = await findAllClientsByNamePaged(name, page, count);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllClientsPagedEvent = async (page, count) => {
    let res = await findAllClientsPaged(page, count);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllOrderListLiveGroupByClientEvent = async (client) => {
    let res = await findAllOrderListLiveGroupByClient(client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findOrderGroupByIdEvent = async (uuid) => {
    let res = await findOrderGroupById(uuid);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllOrderListGroupByClientEvent = async (client) => {
    let res = await findAllOrderListGroupByClient(client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllOrderListGroupDeparturesByClientEvent = async (client) => {
    let res = await findAllOrderListGroupDeparturesByClient(client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllOrderListGroupDeparturesByClientFilterEvent = async (client, filter) => {
    let res = await findAllOrderListGroupDeparturesByClientFilter(client, filter);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllOrderDetailByOrderAndRefAndColorEvent = async (order, ref, color) => {
    let res = await findAllOrderDetailByOrderAndRefAndColor(order, ref, color);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const pdfViewListByOrderEvent = async (order) => {
    let res = await pdfViewListByOrder(order);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const pdfViewListLiveByClientEvent = async (client) => {
    let res = await pdfViewListLiveByClient(client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const pdfViewListByClientEvent = async (client) => {
    let res = await pdfViewListByClient(client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const excelViewListLiveByClientEvent = async (client) => {
    let res = await excelViewListLiveByClient(client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const excelViewListByClientEvent = async (client) => {
    let res = await excelViewListByClient(client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const pdfDepartureListByClientDateEvent = async (client, date) => {
    let res = await pdfDepartureListByClientDate(client, date);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const viewListGenerailViewFilterEvent = async (body) => {
    let res = getRol() === ROLES.seller ? await viewListGenerailSellerViewFilter(body) : await viewListGenerailViewFilter(body);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const viewListGenerailViewFilterByOptionsEvent = async (body) => {
    let res = getRol() === ROLES.seller ? await viewListGenerailViewlSelleFilterByOptions(body) : await viewListGenerailViewFilterByOptions(body);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const viewListGenerailViewFilterByOptionsNotDispatchedEvent = async (body) => {
    let res = getRol() === ROLES.seller ? await viewListGenerailViewlSelleFilterByOptionsNotDispatched(body) : await viewListGenerailViewFilterByOptionsNotDispatched(body);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}